const styles = (theme) => ({
	containerPaper: {
		borderRadius: 3,
		minWidth: "200px",
		height: "100%",
		padding: " 10px",
		display: "flex",
		flexDirection: "column",
		position: "relative",
		overflow: "hidden",
		borderTop: `none `,

		gap: 1,
	},
	container: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		flexDirection: "column",
		padding: "0 10px",
		gap: 2,
	},
	linearProgress: {
		position: "absolute",
		top: 0,
		left: 0,
		width: "100%",
		zIndex: 1,
	},
	speedIcon: {
		position: "absolute",
		bottom: 0,
		right: 8,
		fontSize: 80,
		color: "grey.500",
		opacity: 0.1,
		pointerEvents: "none",
		zIndex: 0,
	},
	titleCard: {
		fontWeight: "bold",
		fontSize: "12px",
		color: theme.palette.colors.white.lighter,
	},
	containerBodyCard: {
		width: "100%",
		display: "flex",
		alignItems: "center",
		justifyContent: "left",
		gap: 2,
	},
	containerIconCard: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		width: "30px",
		height: "30px",
		borderRadius: "50%",
	},
	titleValue: {
		fontWeight: "bold",
		fontSize: "20px",
	},
	status: {
		width: "7px",
		height: "7px",
		borderRadius: "50%",
		backgroundColor: theme.palette.colors.green.light,
		boxShadow: `0 0 5px ${theme.palette.colors.green.light}`,
		animation: "pulse 1.8s infinite ease-in-out",
		"@keyframes pulse": {
			"0%": {
				opacity: 0.4,
				boxShadow: `0 0 5px ${theme.palette.colors.green.light}	`,
			},
			"50%": {
				opacity: 1,
				boxShadow: `0 0 15px ${theme.palette.colors.green.light}	`,
			},
			"100%": {
				opacity: 0.4,
				boxShadow: `0 0 5px ${theme.palette.colors.green.light}	`,
			},
		},
	},
	containerStatus: {
		width: "100%",
		display: "flex",
		justifyContent: "space-between",
		alignItems: "center",
	},
});

export default styles;
